import * as partsLocationDashboard from './partsLocationDashboard';

const reducers = {
  ...partsLocationDashboard,
};

export default reducers;
